/* eslint-disable */
import styles from './index.module.scss'
import { Button, FormButton } from '../../components/core/button'
import StepLine from '../../components/core/stepLine'
import { GeneralInput } from '../../components/core/input'
import { Module } from '../../components/core/module'
import { useState, useRef, useEffect, useContext } from 'react'
import { Account, LangArrows, Map, WorkPlace, Cancel, Plus } from '../../icons'
import { PageContext } from '../../context/PageContextProvider'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'
import SelectsAPI from '../../api/selects'
import VerifyAPI from '../../api/verify'

const HireStep1 = ({ className }) => {
  const [verify, setVerify] = useState(null)
  const [error, setError] = useState(null)
  const [checked, setChecked] = useState(false)
  const [module, setModule] = useState(false)
  const { language, ChangeVerification } = useContext(PageContext)
  const checkRef = useRef(null)

  const defaultCriteria = [
    {
      AZ: 'Mikro sahibkarlıq subyekti',
      ENG: 'Micro business entity',
      RU: 'Субъект микропредпринимательства',
    },
    {
      AZ: 'Kiçik sahibkarlıq subyekti',
      ENG: 'Small business entity',
      RU: 'Субъект малого предпринимательства',
    },
    {
      AZ: 'Orta sahibkarlıq subyekti',
      ENG: 'Medium business entity',
      RU: 'Субъект среднего предпринимательства',
    },
    {
      AZ: 'İri sahibkarlıq subyekti',
      ENG: 'Large business entity',
      RU: 'Субъект крупного предпринимательства',
    },
  ]

  const legalForms = [
    {
      AZ: 'Fiziki şəxs (Fərdi Sahibkar)',
      ENG: 'Individual Entrepreneur',
      RU: 'Физическое лицо (ИП)',
    },
    {
      AZ: 'Məhdud Məsuliyyətli Cəmiyyət (MMC)',
      ENG: 'Limited Liability Company (LLC)',
      RU: 'Общество с ограниченной ответственностью (ООО)',
    },
    {
      AZ: 'Açıq Səhmdar Cəmiyyəti (ASC)',
      ENG: 'Open Joint Stock Company (OJSC)',
      RU: 'Открытое акционерное общество (ОАО)',
    },
    {
      AZ: 'Qapalı Səhmdar Cəmiyyəti (QSC)',
      ENG: 'Closed Joint Stock Company (CJSC)',
      RU: 'Закрытое акционерное общество (ЗАО)',
    },
    {
      AZ: 'Xarici hüquqi şəxsin filial / nümayəndəliyi',
      ENG: 'Branch / Representative office of foreign entity',
      RU: 'Филиал / представительство иностранного юр. лица',
    },
    {
      AZ: 'Digər hüquqi şəxs / QHT',
      ENG: 'Other legal entity / NGO',
      RU: 'Другое юридическое лицо / НПО',
    },
  ]

  const employeeCounts = [
    {
      AZ: '1 – 10 nəfər',
      ENG: '1 – 10 employees',
      RU: '1 – 10 человек',
    },
    {
      AZ: '11 – 50 nəfər',
      ENG: '11 – 50 employees',
      RU: '11 – 50 человек',
    },
    {
      AZ: '51 – 250 nəfər',
      ENG: '51 – 250 employees',
      RU: '51 – 250 человек',
    },
    {
      AZ: '251 və daha çox',
      ENG: '251+ employees',
      RU: '251 и более человек',
    },
  ]

  const getLocalizedText = (item) => {
    if (!item) return ''
    if (typeof item === 'string') return item
    return item[language] || item.AZ || item.ENG || item.RU || item.title || item.name || ''
  }

  const [data, setData] = useState(defaultCriteria)
  const [load, setLoad] = useState(false)

  const [boolTel2, setBoolTel2] = useState(false)
  const [boolTel3, setBoolTel3] = useState(false)
  const [boolTel4, setBoolTel4] = useState(false)
  const [boolTel5, setBoolTel5] = useState(false)
  const [boolTel6, setBoolTel6] = useState(false)
  const [boolTel7, setBoolTel7] = useState(false)
  const [boolTel8, setBoolTel8] = useState(false)
  const [boolTel9, setBoolTel9] = useState(false)
  const [boolTel10, setBoolTel10] = useState(false)

  useEffect(() => {
    (async () => {
      try {
        const res = await SelectsAPI.getEntrepreneurship()
        if (Array.isArray(res?.data) && res.data.length > 0) {
          const valid = res.data.filter(
            (item) => item && (item.AZ || item.ENG || item.RU || typeof item === 'string')
          )
          if (valid.length > 0) {
            setData(valid)
          }
        }
      } catch (e) {
        console.warn('Using default entrepreneurship criteria')
      }
      setLoad(true)
      const nav = document.querySelector('.navbar')
      if (nav) nav.style.filter = module ? 'brightness(0.6)' : 'brightness(1)'
    })()
  }, [])
  const [isVisible7, setIsVisible7] = useState(false)
  const [criteria, setCriteria] = useState(translate.choose[language])
  const [isVisibleLegalForm, setIsVisibleLegalForm] = useState(false)
  const [legalForm, setLegalForm] = useState(translate.choose[language])
  const [isVisibleEmployeeCount, setIsVisibleEmployeeCount] = useState(false)
  const [employeeCount, setEmployeeCount] = useState(translate.choose[language])

  useEffect(() => {
    setCriteria(translate.choose[language])
    setLegalForm(translate.choose[language])
    setEmployeeCount(translate.choose[language])
  }, [language])
  const steps = [
    {
      title: translate.add_info,
      text: translate.add_address,
    },
    {
      title: translate.select_service,
      text: translate.select_service_text,
    },
    {
      title: translate.finish,
      text: translate.finish_text,
    },
  ]
  const addTel = () => {
    if (!boolTel2) {
      setBoolTel2(true)
    } else if (!boolTel3) {
      setBoolTel3(true)
    } else if (!boolTel4) {
      setBoolTel4(true)
    } else if (!boolTel5) {
      setBoolTel5(true)
    } else if (!boolTel6) {
      setBoolTel6(true)
    } else if (!boolTel7) {
      setBoolTel7(true)
    } else if (!boolTel8) {
      setBoolTel8(true)
    } else if (!boolTel9) {
      setBoolTel9(true)
    } else if (!boolTel10) {
      setBoolTel10(true)
    }
  }
  const sendAppeal = () => {
    const fullname = document.querySelector('#hire-fullname')?.value.trim()
    if (fullname === '') {
      alert(translate.alert[language])
      return
    }
    const birth = document.querySelector('#hire-birth')?.value.trim()
    if (birth === '') {
      alert(translate.alert[language])
      return
    }
    const phone1 = document.querySelector('#hire-phone1')?.value.trim() || ''
    if (phone1 === '') {
      alert(translate.alert[language])
      return
    }
    if (
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone1,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone2 = document.querySelector('#hire-phone2')?.value.trim() || ''
    if (
      phone2 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone2,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone3 = document.querySelector('#hire-phone3')?.value.trim() || ''
    if (
      phone3 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone3,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone4 = document.querySelector('#hire-phone4')?.value.trim() || ''
    if (
      phone4 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone4,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone5 = document.querySelector('#hire-phone5')?.value.trim() || ''
    if (
      phone5 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone5,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone6 = document.querySelector('#hire-phone6')?.value.trim() || ''
    if (
      phone6 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone6,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone7 = document.querySelector('#hire-phone7')?.value.trim() || ''
    if (
      phone7 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone7,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone8 = document.querySelector('#hire-phone8')?.value.trim() || ''
    if (
      phone8 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone8,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone9 = document.querySelector('#hire-phone9')?.value.trim() || ''
    if (
      phone9 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone9,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    const phone10 = document.querySelector('#hire-phone10')?.value.trim() || ''
    if (
      phone10 !== '' &&
      !/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
        phone10,
      )
    ) {
      alert(translate.alert_phone[language])
      return
    }
    let phones = [
      phone1,
      phone2,
      phone3,
      phone4,
      phone5,
      phone6,
      phone7,
      phone8,
      phone9,
      phone10,
    ]
    phones = phones.filter((item) => item !== '')
    const email = document.querySelector('#hire-email')?.value.trim()
    if (email === '') {
      alert(translate.alert[language])
      return
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      alert(translate.alert_email[language])
      return
    }
    const factual = document.querySelector('#hire-factual')?.value.trim()
    if (factual === '') {
      alert(translate.alert[language])
      return
    }
    const legal = document.querySelector('#hire-legal')?.value.trim()
    if (legal === '') {
      alert(translate.alert[language])
      return
    }
    const voen = document.querySelector('#hire-voen')?.value.trim()
    if (voen === '') {
      alert(translate.alert[language])
      return
    }
    const code = document.querySelector('#hire-activity-code')?.value.trim()
    if (code === '') {
      alert(translate.alert[language])
      return
    }
    const experience = document
      .querySelector('#hire-experience-company')
      ?.value.trim()
    if (experience === '') {
      alert(translate.alert[language])
      return
    }
    const factual_country = document
      .querySelector('#hire-factual-country')
      ?.value.trim()
    if (factual_country === '') {
      alert(translate.alert[language])
      return
    }
    const factual_city = document
      .querySelector('#hire-factual-city')
      ?.value.trim()
    if (factual_city === '') {
      alert(translate.alert[language])
      return
    }
    const factual_address = document
      .querySelector('#hire-factual-address')
      ?.value.trim()
    if (factual_address === '') {
      alert(translate.alert[language])
      return
    }
    const legal_country = checked
      ? factual_country
      : document.querySelector('#hire-legal-country')?.value.trim()
    if (legal_country === '') {
      alert(translate.alert[language])
      return
    }
    const legal_city = checked
      ? factual_city
      : document.querySelector('#hire-legal-city')?.value.trim()
    if (legal_city === '') {
      alert(translate.alert[language])
      return
    }
    const legal_address = checked
      ? factual_address
      : document.querySelector('#hire-legal-address')?.value.trim()
    if (legal_address === '') {
      alert(translate.alert[language])
      return
    }
    const note = document.querySelector('#hire-note')?.value.trim()
    const data = {
      fullname,
      birth,
      phones,
      email,
      workPlace: {
        factualWorkplace: factual,
        legalWorkplace: legal,
        entrepreneurshipCriteria: criteria,
        legalForm: legalForm === translate.choose[language] ? '' : legalForm,
        employeeCount: employeeCount === translate.choose[language] ? '' : employeeCount,
        voen: voen,
        activityCode: code,
        experience_of_company: experience,
        factualAddress: `${factual_country}, ${factual_city}, ${factual_address}`,
        legalAddress: `${legal_country}, ${legal_city}, ${legal_address}`,
      },
      note,
      options: [],
    }
    sessionStorage.setItem('hire', JSON.stringify(data))
    window.location.href = '/remote-hire-step2'
  }
  return load ? (
    <>
      <section className={`${className} ${styles.container}`}>
        <StepLine active={0} data={steps} />
        <div className={`${styles.content}`}>
          <h2>
            <Account /> {translate.about[language]}
          </h2>
          <div className={styles.about}>
            <GeneralInput
              id={'hire-fullname'}
              label={translate.fullname[language]}
              type="text"
              placeholder={translate.enter_fullname[language]}
            />
            <GeneralInput
              id={'hire-birth'}
              label={translate.date[language]}
              type="date"
            />
          </div>
          <div className={styles.gender}>
            <GeneralInput
              label={translate.phone[language]}
              id="hire-phone1"
              type="tel"
              placeholder="+994 XX XXX XX XX"
            />
            {boolTel2 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  type="tel"
                  id="hire-phone2"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel2(false)} />
              </div>
            ) : null}
            {boolTel3 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone3"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel3(false)} />
              </div>
            ) : null}
            {boolTel4 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone4"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel4(false)} />
              </div>
            ) : null}
            {boolTel5 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone5"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel5(false)} />
              </div>
            ) : null}
            {boolTel6 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone6"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel6(false)} />
              </div>
            ) : null}
            {boolTel7 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone7"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel7(false)} />
              </div>
            ) : null}
            {boolTel8 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone8"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel8(false)} />
              </div>
            ) : null}
            {boolTel9 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone9"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel9(false)} />
              </div>
            ) : null}
            {boolTel10 ? (
              <div>
                <GeneralInput
                  label={translate.phone[language]}
                  id="hire-phone10"
                  type="tel"
                  placeholder="+994 XX XXX XX XX"
                />
                <Cancel onClick={() => setBoolTel10(false)} />
              </div>
            ) : null}
          </div>
          {!boolTel10 && (
            <button
              onClick={() => {
                addTel()
              }}
              className={styles.button}
            >
              <Plus /> {translate.add_tel[language]}
            </button>
          )}
          <div className={styles.email}>
            <GeneralInput
              label={translate.email[language]}
              type="text"
              id="hire-email"
              placeholder={translate.email_ph[language]}
              onInput={(e) => {
                setError(
                  !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
                    e.target.value,
                  ),
                )
              }}
              style={{
                border: error ? '1px solid red' : '1px solid #C5CEE0',
                width: '100%',
              }}
            />
          </div>
          <h2>
            <WorkPlace /> {translate.about_work[language]}
          </h2>
          <div className={styles.work}>
            <GeneralInput
              label={translate.factual[language]}
              id="hire-factual"
              type="text"
              placeholder={translate.enter_name[language]}
            />
            <GeneralInput
              label={translate.legal[language]}
              id="hire-legal"
              type="text"
              placeholder={translate.enter_name[language]}
            />
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisible7(false)
                }, 250)
              }
            >
              <p>{translate.entrepreneurship[language]}</p>
              <span tabIndex="1" onClick={() => setIsVisible7(true)}>
                {criteria} <LangArrows />
              </span>
              <ul
                style={isVisible7 ? { display: 'block' } : { display: 'none' }}
              >
                {data && data.filter(Boolean).map((e, idx) => {
                  const text = getLocalizedText(e)
                  if (!text) return null
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setCriteria(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisibleLegalForm(false)
                }, 250)
              }
            >
              <p>{language === 'AZ' ? 'Təşkilati-Hüquqi forması' : language === 'TR' ? 'Hukuki Yapı / Şirket Türü' : language === 'RU' ? 'Организационно-правовая форма' : 'Legal & Organizational Form'}</p>
              <span tabIndex="1" onClick={() => setIsVisibleLegalForm(true)}>
                {legalForm} <LangArrows />
              </span>
              <ul
                style={isVisibleLegalForm ? { display: 'block' } : { display: 'none' }}
              >
                {legalForms.map((e, idx) => {
                  const text = getLocalizedText(e)
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setLegalForm(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <div
              className={styles.select}
              onBlur={() =>
                setTimeout(function () {
                  setIsVisibleEmployeeCount(false)
                }, 250)
              }
            >
              <p>{language === 'AZ' ? 'İşçi sayı' : language === 'TR' ? 'Çalışan Sayısı' : language === 'RU' ? 'Количество сотрудников' : 'Number of Employees'}</p>
              <span tabIndex="1" onClick={() => setIsVisibleEmployeeCount(true)}>
                {employeeCount} <LangArrows />
              </span>
              <ul
                style={isVisibleEmployeeCount ? { display: 'block' } : { display: 'none' }}
              >
                {employeeCounts.map((e, idx) => {
                  const text = getLocalizedText(e)
                  return (
                    <li
                      key={idx}
                      onClick={() => {
                        setEmployeeCount(text)
                      }}
                    >
                      {text}
                    </li>
                  )
                })}
              </ul>
            </div>
            <GeneralInput
              label={translate.voen[language]}
              id="hire-voen"
              type="text"
              placeholder={translate.enter_code[language]}
            />
            <GeneralInput
              label={translate.activity_code[language]}
              id="hire-activity-code"
              type="text"
              placeholder={translate.enter_info[language]}
            />
            <GeneralInput
              label={translate.experience_company[language]}
              id="hire-experience-company"
              type="date"
            />
          </div>
          <h2>
            <Map /> {translate.workplace[language]}
          </h2>
          <div className={styles.address}>
            <p>{translate.factual_address[language]}</p>
            <div>
              <GeneralInput
                label={translate.country[language]}
                id="hire-factual-country"
                type="text"
                placeholder={translate.enter_info[language]}
              />
              <GeneralInput
                label={translate.city[language]}
                id="hire-factual-city"
                type="text"
                placeholder={translate.enter_info[language]}
              />
              <GeneralInput
                label={translate.address[language]}
                id="hire-factual-address"
                type="text"
                placeholder={translate.enter_info[language]}
              />
            </div>
            <label>
              <input
                onClick={() => {
                  setChecked(!checked)
                }}
                checked={checked}
                type="checkbox"
                ref={checkRef}
              />
              {translate.same_address[language]}
            </label>
            {!checked && <p>{translate.legal_address[language]}</p>}
            {!checked && (
              <div>
                <GeneralInput
                  label={translate.country[language]}
                  type="text"
                  id="hire-legal-country"
                  placeholder={translate.enter_info[language]}
                />
                <GeneralInput
                  label={translate.city[language]}
                  type="text"
                  id="hire-legal-city"
                  placeholder={translate.enter_info[language]}
                />
                <GeneralInput
                  label={translate.address[language]}
                  type="text"
                  id="hire-legal-address"
                  placeholder={translate.enter_info[language]}
                />
              </div>
            )}
          </div>
          <div className={styles.textarea}>
            <p>{translate.note[language]}</p>
            <span>{translate.not_required[language]}</span>
            <textarea
              id="hire-note"
              placeholder={translate.write_note[language]}
            ></textarea>
          </div>
          <FormButton onClick={() => sendAppeal()}>
            {translate.save_next[language]}
          </FormButton>
        </div>
      </section>
      {module && (
        <div className={styles.module}>
          <Module
            email={document.getElementById('hire-email').value.trim()}
            setModule={setModule}
            setVerify={setVerify}
            click={() => {
              setModule(false)
            }}
            verify={verify}
          />
        </div>
      )}
    </>
  ) : (
    <Loading />
  )
}

export default HireStep1
